import { motion } from 'framer-motion';

export const AnimatedLetters = ({ word }) => {
  const letters = word.split('');

  return (
    <span className="inline-block">
      {letters.map((letter, i) => (
        <motion.span
          key={i}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.05, duration: 0.3 }}
          className="inline-block"
        >
          {letter}
        </motion.span>
      ))}
    </span>
  );
};
